module.exports = __webpack_public_path__ + "img/mexico-logo-icon.8e226dfd.png";